/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "c2772985734df99d933269fb0d6a39f7f915f38e";
